import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const CookiePolicyPage: React.FC = () => (
  <LegalPageLayout title="Cookie and Storage Policy" updated="August 14, 2026">
    <p>
      Bilt uses browser and device storage to keep you signed in and remember preferences. Much of this is local storage
      rather than classic third-party cookies.
    </p>
    <h2>Strictly necessary</h2>
    <ul>
      <li>Authentication tokens (web localStorage / mobile Secure Store)</li>
      <li>Session helpers for invite codes, showcase mode, and view-session dedupe</li>
      <li>Security and fraud controls</li>
    </ul>
    <h2>Preferences</h2>
    <p>Cookie consent choices and some UI preferences.</p>
    <h2>Analytics</h2>
    <p>First-party product analytics and optional Google Analytics only when configured and consented.</p>
    <h2>Advertising</h2>
    <p>
      Bilt sponsorship is primarily contextual. Optional advertising storage is off unless you accept it. GPC signals are
      honored as advertising opt-out where applicable.
    </p>
    <h2>Manage choices</h2>
    <p>Use Cookie preferences in the footer or Settings → Privacy and data.</p>
  </LegalPageLayout>
);

export default CookiePolicyPage;
